MemoModalCtrl = ($scope, $modalInstance, MemoService, modalModel) ->
  $scope.memo = modalModel.memo

  $scope.ok = ->
    memo = $scope.memo
    MemoService.updateMemo(modalModel.id, memo).then (resp) ->
      $modalInstance.close(memo)

  $scope.cancel = ->
    $modalInstance.dismiss('cancel')

MemoModalCtrl.$inject = [
  '$scope'
  '$modalInstance'
  'MemoService'
  'modalModel'
]

module.exports = MemoModalCtrl




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/round-detail/score-card-memo/memo-modal-controller.coffee